// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_h2-a";
export var fulfillmentFormRail = "_h2-9";
export var headerTitleRow = "_h2-c";
export var orderDetailsWrapper = "_h2-7";
export var orderLinkTrigger = "_h2-2";
export var paymentInformationGrid = "_h2-h";
export var paymentSummaryColumn = "_h2-i";
export var shipmentContainer = "_h2-b";
export var shipmentDetailsMainPane = "_h2-8";
export var shipmentNavigationCard = "_h2-5";
export var shipmentNavigationRail = "_h2-3";
export var shipmentNavigationRailHeader = "_h2-4";
export var shipmentSummaryFact = "_h2-e";
export var shipmentSummaryGrid = "_h2-d";
export var shipmentSummaryMetadataRow = "_h2-f";
export var shipmentSummaryTags = "_h2-g";
export var shipmentWorkspace = "_h2-0";
export var shipmentWorkspaceContent = "_h2-6";
export var shipmentWorkspaceHeader = "_h2-1";